import { DetailsBooking } from 'types';
import { format } from 'date-fns';

const CHECK_IN_DATE_FORMAT = "E d MMM, yyyy. 'From' ha";
const CHECK_OUT_DATE_FORMAT = "E d MMM, yyyy. 'Until' ha";

const createLocalDateTime = (localDateString: string, localTimeString: string) => {
  const [year, month, date] = localDateString.split('-');
  const [hours, minutes] = localTimeString.split(':');
  return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(date, 10), parseInt(hours, 10), parseInt(minutes, 10));
};

const getFormattedCheckInDateTime = (booking: DetailsBooking) => {
  const {
    checkIn,
    property: { checkInAfter },
  } = booking.reservation;
  const localDate = createLocalDateTime(checkIn, checkInAfter);
  return format(localDate, CHECK_IN_DATE_FORMAT);
};

const getFormattedCheckOutDateTime = (booking: DetailsBooking) => {
  const {
    checkOut,
    property: { checkOutBefore },
  } = booking.reservation;
  const localDate = createLocalDateTime(checkOut, checkOutBefore);
  return format(localDate, CHECK_OUT_DATE_FORMAT);
};

const descriptionTemplate = (booking: DetailsBooking) =>
  `You're staying ${booking.summaryText}. Enjoy your trip.


Booking details

Check-in date: ${getFormattedCheckInDateTime(booking)}
Check-out date: ${getFormattedCheckOutDateTime(booking)}
Guests: ${guestSummaryTemplate(booking)}
View your booking online:
${booking.links.manage}


Hotel details

Room: ${booking.reservation.roomType.name}
Address: ${booking.reservation.property.formattedAddressFull}
`;

const guestSummaryTemplate = (booking: DetailsBooking) => {
  const { adults, children, infants } = booking.reservation;
  const { given, family } = booking.reservation.leadGuest.name;

  let occupantsText = '';
  const addOccupantGroup = (count: number, singular: string, plural: string) => {
    occupantsText += count === 0 ? '' : count === 1 ? `${count} ${singular}, ` : `${count} ${plural}, `;
  };

  addOccupantGroup(adults, 'adult', 'adults');
  addOccupantGroup(children, 'child', 'children');
  addOccupantGroup(infants, 'infant', 'infants');

  return `${occupantsText}reserved for ${given} ${family}`;
};

export const getCalendarFields = (booking: DetailsBooking) => {
  return {
    location: booking.reservation.property.formattedAddressFull,
    startDate: new Date(booking.reservation.checkInDateTime),
    endDate: new Date(booking.reservation.checkOutDateTime),
    title: booking.summaryText,
    url: booking.links.manage,
    description: descriptionTemplate(booking),
  };
};
